var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 1739",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(598,738)",
    d: "m0 0h79l15 4 12 7 8 8 7 11 6 18 9 52 1 10 4 7 12 6 28 11 21 9 15 6 10 5 4-1 28-21 15-10 13-9 14-7 13-3h13l12 3 14 7 10 8 10 9 27 27 9 12 9 16 3 12v17l-3 11-10 17-11 16-10 14-12 17-4 7 3 9 7 16 13 32 9 22 5 8v2l25 5 44 8 16 5 14 9 7 8 6 11 2 5 1 8 2 33v21l-2 31-4 13-7 11-5 6-9 6-18 6-29 6-32 6-12 4-4 8-13 32-12 29-6 17 1 5 10 16 14 19 12 18 8 15 3 9 1 6v14l-2 10-7 13-11 13-40 40-10 8-11 5-10 2h-23l-10-3-18-11-17-12-15-11-17-11-4-1-9 4-71 29-5 2-4 16-5 25-5 31-5 14-6 10-9 10-5 4-9 4-17 4-15 2h-49l-21-3-13-5-10-9-6-7-7-14-5-18-10-56-3-6-5-4-68-28-10-5h-6l-11 8-17 12-19 13-14 9-11 5-10 2h-24l-12-5-11-8-16-15-25-25-11-14-8-16-3-10v-9l5-19 7-13 8-11 28-40 3-4-2-9-12-29-14-34-6-14-5-6-4-2-35-5-17-3-18-4-13-5-11-8-6-7-8-16-3-11v-76l4-16 4-8 8-10 13-10 10-4 31-6 33-6 9-1 4-2 8-14 15-37 12-29 3-5-1-7-24-34-14-20-8-16-3-9-2-10 1-7 5-15 6-10 12-14 14-14 9-10 5-5 13-12 14-9 15-5 11-1 16 4 16 8 19 13 17 12 16 11 5 4 6-2 35-15 28-11 17-7 4-6 8-42 6-29 5-13 6-9 8-9 14-8zm21 321-19 3-20 6-18 8-17 10-13 10-15 14-12 14-11 17-11 23-6 20-3 15-2 25 1 21 5 24 7 19 12 23 13 18 12 13 13 11 18 12 16 9 15 6 17 5 24 4h16l23-3 22-5 20-8 20-11 11-8 14-12 11-11 9-11 7-10 13-26 7-24 4-25 1-10v-10l-2-14-4-21-8-22-10-19-8-12-10-13-12-13-17-13-16-10-21-10-17-5-20-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1406,187)",
    d: "m0 0h50l18 2 17 5 12 7 10 9 7 9 7 15 5 19 6 35 4 20 4 4 29 11 28 12 11 4h6l9-6 11-8 15-11 15-10 16-8 10-3 9-1h13l15 3 16 8 12 9 15 13 25 25 12 16 9 17 4 14 1 12-3 15-5 13-8 15-8 12-13 18-12 16 1 8 10 24 10 26 7 17 7 4 48 8 20 5 14 6 13 10 8 9 7 11 4 11 2 11 1 17v49l-2 21-5 15-6 11-11 12-9 7-15 6-27 6-33 6-15 4-12 29-8 21-8 18-1 8 12 17 13 18 10 15 8 16 5 16 1 13-3 14-5 12-7 12-13 16-32 32-8 7-13 9-12 5-15 4h-18l-15-4-14-6-17-11-12-9-19-14-6-4-9 2-28 12-27 11-11 5-2 8-9 52-5 17-9 17-9 10-7 6-13 6-17 4-19 2-36 1-25-1-15-3-11-4-11-7-13-13-8-14-6-18-5-26-5-33-2-5-18-7-21-8-24-10-11-4-5 2-11 8-16 11-15 11-14 8-16 6-12 3h-11l-15-3-12-5-12-8-13-11-32-32-10-13-9-15-5-16v-25l3-12 8-16 14-19 14-21 6-8 1-8-9-24-11-27-6-15-2-4-9-4-48-8-20-5-16-8-10-9-6-7-8-14-4-13-3-22v-52l3-20 5-15 7-12 9-10 13-9 13-5 25-6 43-7 6-4 7-14 6-17 13-32 2-6-1-7-10-15-12-17-10-15-9-17-5-15v-24l5-15 9-14 9-11 12-13 28-28 11-8 14-8 11-4 6-1h19l16 4 16 8 11 7 17 13 11 8 10 7h7l19-7 31-13 16-6 5-4 5-25 7-37 6-18 7-13 9-10 12-9 15-6 18-3zm0 31-18 3-11 4-10 9-6 13-4 15-7 41-4 21-5 8-10 6-31 13-32 13-18 6-8 2h-7l-12-5-12-8-36-26-16-8-12-3-9 2-15 8-14 12-23 23-7 8-9 13-5 12v13l4 12 7 12 13 18 12 17 10 15 4 11-2 10-8 21-17 42-11 23-7 9-25 5-44 8-12 3-12 6-5 4-7 10-4 14-2 14-1 14v19l2 20 4 15 4 8 5 6 14 8 17 4 54 9 10 3 6 4 5 9 9 21 13 32 11 27 3 11-1 7-7 13-11 15-11 16-12 18-6 12-3 11 2 11 6 12 12 14 28 28 8 7 8 6 12 6 3 1h8l20-9 21-14 18-13 13-9 11-6h8l14 4 28 11 45 19 11 6 5 6 5 25 7 43 3 11 7 14 5 6 12 6 8 2 10 1h58l12-2 10-4 8-7 8-16 4-16 8-48 5-16 7-6 16-8 23-10 41-17 11-4h10l14 7 34 24 18 12 13 6 6 2h9l16-8 11-8 13-12 15-15 9-11 7-9 7-14v-10l-5-13-7-13-10-15-13-18-10-15-6-11v-9l10-25 16-39 6-15 7-14 7-6 13-4 47-8 20-5 12-6 8-7 5-8 3-14v-69l-4-14-7-10-8-6-13-5-19-4-31-5-25-5-6-4-8-16-12-28-12-29-6-15-3-10 1-8 9-17 10-13 11-16 12-18 5-10 3-9v-10l-5-12-9-12-12-13-27-27-11-8-10-5-12-2-14 5-10 5-28 20-18 13-13 6-3 1h-7l-15-4-40-16-34-14-8-5-4-5-4-14-7-42-5-21-5-13-7-9-9-6-16-4-7-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1428,506)",
    d: "m0 0 24 1 20 3 20 6 19 8 17 10 16 12 14 12 13 14 10 14 10 17 8 17 7 21 4 20 1 12v29l-2 18-6 25-8 21-9 17-12 17-11 13-12 12-10 8-13 9-16 9-23 9-19 5-24 4-13 1h-17l-19-2-21-5-19-7-16-8-14-8-14-11-12-11-11-12-10-13-11-18-9-19-8-24-3-14-2-16v-27l3-22 6-22 6-16 11-21 10-15 9-11 12-13 10-9 14-10 17-10 15-7 21-7 22-4zm-6 31-21 3-22 6-16 7-13 7-13 9-10 9-13 13-10 14-10 17-8 19-5 18-3 19v22l3 20 6 20 9 20 8 12 10 13 11 12 10 9 17 12 15 8 19 7 18 4 9 1h35l21-4 18-6 16-8 12-7 13-10 12-11 9-10 11-17 8-16 6-17 4-20 1-7v-35l-3-19-7-21-11-21-10-14-12-14-11-10-13-9-15-9-18-8-18-5-21-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1575,647)",
    d: "m0 0h4v2h7l5 5 4 5-1 7-1 3h2v-3l4 2 3 6 1 7v6l1 5-2 8 1 8-2 8v4h3v4l-6 4-2 6-2 1v2l-5 1v-2l-2-1v-2h-2l-2-5-2-1 4-11-1-2 1-4-2-1-5 9h-1l1-13v-35l-3-19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1251,654)",
    d: "m0 0h2l2 9 1 3v9h3l1 8v18l-2 9-4 9-5-1-2-16v-27l2-16z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1428,506)",
    d: "m0 0 19 1-4 4 2 1-4 1v2l-12 3h-18l-17 1-7-3h-2l-2-4 13-3 15-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,649)",
    d: "m0 0 3 3 1 12v38l-2 9-1 2h-3v-52z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1560,613)",
    d: "m0 0 3 1 1 4 20 10 3 2h7l2 6-4 1-6-3-11-2-8-4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(635,1050)",
    d: "m0 0 11 1 4 1 5 3v3h-26l-5-2v-3l5-2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,1598)",
    d: "m0 0h29l7 1v4l-3 1h-23l-10-3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1286,596)",
    d: "m0 0h2l-1 4h3l-1 4-4 3-2 5-6-3v-3l-4 1-3 3h-4l1-5 3-6 4-1v2l8 1h2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1508,1072)",
    d: "m0 0 3 1 1 9h2l-1 4-5 14-4 8h-1v-9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1118,1173)",
    d: "m0 0 2 1 1 8 1 20v14l-3 1-3-13 1-11z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1122,1231)",
    d: "m0 0h1l-2 36-2 7-2-4v-19l2-15z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1899,670)",
    d: "m0 0 2 1 2 18-1 8v20l-2 3-2 1 1-17z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1424,865)",
    d: "m0 0h14l3 2v2l-8 1h-17l-9-1-2-2 16-1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1434,1185)",
    d: "m0 0 12 1-1 2-28 1-18-1 4-2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1256,742)",
    d: "m0 0 1 2 4 2 6-1 2 2 4 1 1 3-2 2h-7v-2l-5-2-1 3-3-7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1807,575)",
    d: "m0 0 6 2 4 3-3 4 2 3h-4l-6-4-1-5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1432,840)",
    d: "m0 0h15l2 2h-2v2l-6 1h-12l-2-2 5-1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1082,503)",
    d: "m0 0 3 3-1 14-4-1-1-3-2-1 3-9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1529,246)",
    d: "m0 0 2 2 3 15v5l-4-3-4-12z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,1491)",
    d: "m0 0 2 2 1 6v14l-1 7-2 1-1-26z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1078,861)",
    d: "m0 0 7 2 1 6-2 5-4-1-3-11z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1465,537)",
    d: "m0 0 6 1 6 4-1 2-11-2-13-3v-1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1436,532)",
    d: "m0 0h5l9 4-2 2-20-1v-1l5-1v-2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1061,1307)",
    d: "m0 0 4 2 2 2-12 3h-8v-2l11-4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1246,1030)",
    d: "m0 0 5 2 3 3 1 5-10-3-2-2v-4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1058,565)",
    d: "m0 0 2 3-4 10-4 1-3-3 4-5 3-5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(803,1209)",
    d: "m0 0 3 4 1 11v4l-4 2-1-5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1846,608)",
    d: "m0 0 8 3 4 2-1 3-10-1-4-4z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1011,957)",
    d: "m0 0h2l1 2v7l-2 4h-3l-1-2v-7z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1891,634)",
    d: "m0 0 4 2 3 3 1 9v11h-1l-3-14-4-9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,932)",
    d: "m0 0 2 3v17l-2 3-1-6v-13z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,578)",
    d: "m0 0 5 2 1 4-3 3-4-2h-2l-3-1z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1776,871)",
    d: "m0 0h1l2 9 3 4v2l-4-1-4-5-1-4z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1040,1131)",
    d: "m0 0 13 1 10 2v1h-15l-7-2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1530,1117)",
    d: "m0 0h2v9l-2 6-3-1-1-4 1-3h2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1599,627)",
    d: "m0 0 3 1 2 6v4l-5-1-1-8z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1409,535)",
    d: "m0 0 5 1 3 2-11 2h-4l1-3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1794,964)",
    d: "m0 0h2l5 8-1 4h-3l-3-9z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,738)",
    d: "m0 0h14l-1 3h-12z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1021,610)",
    d: "m0 0 5 1-3 2-6 1h-8l1-3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(340,1600)",
    d: "m0 0 8 2 10 1v1h-18z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1059,770)",
    d: "m0 0 9 2 4 2v2l-7-1-6-4z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1107,854)",
    d: "m0 0 3 4 1 7-3-1v-3h-2l-1-6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1771,569)",
    d: "m0 0 5 2v2h2v3h-5l-2-3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1319,1071)",
    d: "m0 0 3 2 1 9-2 4-2-9z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1580,651)",
    d: "m0 0h3l3 3 2 6h-3l-3-4v-3h-2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1643,1014)",
    d: "m0 0 7 4 3 2v2l-4-1-6-4z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1363,856)",
    d: "m0 0h5l5 3v2l-9-2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(990,787)",
    d: "m0 0 12 2 1 2h-8l-6-2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,750)",
    d: "m0 0 5 3 1 5-4-1-2-4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(993,586)",
    d: "m0 0 4 1-7 3h-7l2-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/service.7bfca546777ed1bc160ad39b6895208e.svg";
export { ForwardRef as ReactComponent };